// https://stackblitz.com/edit/angular-configuration-with-app-initializer?file=src%2Fapp%2Fapp.component.ts
// https://ichi.pro/es/como-funciona-app-initializer-entonces-que-necesita-saber-sobre-la-configuracion-dinamica-en-angular-124856783100273

import { NgModule, APP_INITIALIZER } from '@angular/core';
import { HttpClientModule } from "@angular/common/http";

import { ConfigurationInitService } from './configuration-init.service';

export function loadConfiguration(configService: ConfigurationInitService)
  {
    return () => configService.loadConfiguration();
  }

@NgModule({
  declarations: [],
  imports: [
    HttpClientModule
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: loadConfiguration,
      deps: [ConfigurationInitService],
      multi: true
    }
  ]
})
export class ConfigurationModule { }
